import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('QuestionResources')
export default class QuestionResources {
  constructor() {
    this.resourceUri = '';
    this.resourceFileName = '';
    this.alternativeText = undefined;
    this.contents = undefined;
    this.contentType = '';
    this.localSrcUri = '';
  }

  @JsonProperty('resource_uri')
  public resourceUri: string;

  @JsonProperty('resource_file_name')
  public resourceFileName: string;

  @JsonProperty('alternative_text', null, true)
  public alternativeText?: string;

  public contents?: Blob;

  public contentType: string;

  public localSrcUri: string;
}
